module.exports = __webpack_public_path__ + "img/home_welcome.f876e4f7.webp";